import React, { Component } from 'react';
import { connect } from 'react-redux';
import QuillForm from './QuillForm';
import FlipMove from 'react-flip-move';
import CommentItem from './CommentItem';
import {
    fetchComments,
} from "../redux/actions";
import {
    authSelector, commentSelector, rankSelector, userSelector,
} from "../redux/selectors";
import {toArray} from "./util";


class Comments extends Component {

    componentDidMount() {
        this.props.getComments(this.props.item);
    }

    render() {
        const commentItems = toArray(this.props.comments.data)
            .sort((a, b) => (new Date(a.created).getTime() - new Date(b.created).getTime()))
            .filter(comment => comment.contentObject === this.props.item.split('/')[1] +': '  + this.props.item.split('/')[2])
            .map((comment) => (
            <div key={`${comment.id}-comment`}>
                <CommentItem item={comment} users={this.props.users} ranks={this.props.ranks} />
            </div>
        ));
        return (
            <div>
                <div className="panel-adt">
                    <QuillForm minSecurity={this.props.minSecurity} api={this.props.item} count={toArray(this.props.comments.data).filter(comment => comment.contentObject === this.props.item.split('/')[1] +': ' + this.props.item.split('/')[2]).length} />
                </div>
                <FlipMove
                    staggerDelayBy={50}
                    appearAnimation="fade"
                    enterAnimation="fade"
                    leaveAnimation="fade"
                    className="comments"
                >
                    {commentItems}
                </FlipMove>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    auth: authSelector(state),
    comments: commentSelector(state),
    users: userSelector(state),
    ranks: rankSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getComments: (item) => dispatch(fetchComments(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comments);







// WEBPACK FOOTER //
// ./src/common/Comments.js